// icons
import { IconShoppingBag } from "@tabler/icons-react";
// link
import { Link } from "react-router";
// spliter
import { splitNumber } from "../../features/splitNumber/splitNumber";
// icon
import Heart from "../heart/heart";

const ProductsCard = (props: any) => {
    return (
        <>
            <div className="card new-product-card border-0 rounded rounded-4 shadow">
                <div className=" rounded rounded-4 p-3">
                    <span className="badge bg-white text-dark icon shadow">
                        {props?.has_variation !== 0 ? (
                            <>
                                {props.quantity_check?.price ? (
                                    <span className="card-title price font-medium-lg">محصولات</span>
                                ) : (
                                    <span className="card-title text-danger fw-bold price text-danger  font-medium-lg">نا موجود</span>
                                )}
                            </>
                        )
                            :
                            (
                                <>
                                    {props.price ? (
                                        <>
                                            <span className="card-title price font-medium-lg">محصولات</span>
                                        </>
                                    ) : (
                                        <>
                                            <span className="card-title text-danger fw-bold price text-danger  font-medium-lg">نا موجود</span>
                                        </>
                                    )}
                                </>
                            )
                        }
                    </span>
                    <div className="d-flex justify-content-center align-items-center">
                        <Link to={`/products/detail/${props.slug}`} className="text-decoration-none">
                            <img src={props.primary_image} alt="product" />
                        </Link>
                    </div>
                    <div className="color-place icon">
                        <div className="like-place shadow">
                            <Heart id={props.id} />
                        </div>
                    </div>
                </div>
                <div className="card-body mt-1">
                    <Link to={`/products/detail/${props.slug}`} className="text-decoration-none">
                        <div className="d-flex justify-content-between align-items-center" style={{ height: '40px' }}>
                            <span className="text-dark w-100 text-line font-medium-lg mb-0">
                                {props.name}
                            </span>
                        </div>
                        <hr />
                        <div className="d-flex align-items-center justify-content-between">
                            <Link to={`/products/detail/${props.slug}`} className="btn btn-primary py-1">
                                <IconShoppingBag size={16} className="align-middle me-1" />
                                خرید
                            </Link>
                            {props?.has_variation !== 0 ? (
                                <>
                                    {props.quantity_check?.price ? (
                                        <span className="card-title price font-medium-lg">محصولات</span>
                                    ) : (
                                        <span className="card-title text-danger fw-bold price text-danger  font-medium-lg">نا موجود</span>
                                    )}
                                </>
                            )
                                :
                                (
                                    <>
                                        {props.price ? (
                                            <>
                                                <span className="card-title price font-medium mt-2">{splitNumber(props.price)}</span>
                                            </>
                                        ) : (
                                            <>
                                                <span className="card-title text-danger fw-bold price text-danger  font-medium-lg">نا موجود</span>
                                            </>
                                        )}
                                    </>
                                )
                            }
                        </div>
                    </Link>
                </div>
            </div >
        </>
    )
}
export default ProductsCard;